import React, { Fragment } from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import { amountFormat } from "../../../../utils";
import NoData from "./NoData";
const ExpenseTableData = ({ data, expensesData }) => {
  const styles = StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      fontStyle: "bold",
      paddingBottom: "5px",
      paddingTop: "10px",
      paddingLeft: "15px",
      border: "1px solid #E4E4E4",
      borderRadius: "5px",
      width: "100%",
      marginTop: "5px",
    },
    one: {
      width: "10%",
      fontSize: "11px",
      color: "#333333",
    },
    two: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    three: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    four: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    five: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    six: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    anountContainer: {
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "10px",
    },
    amountText: {
      flexDirection: "column",
      alignItems: "flex-end",
      fontSize: "11px",
      color: "#454545",
      marginRight: "10px",
    },
    amountValues: {
      flexDirection: "column",
      alignItems: "flex-end",
      fontSize: "11px",
      color: "#454545",
      marginRight: "15px",
    },
    amountFooter: {
      width: "100%",
      backgroundColor: "#E4E4E4",
      paddingBottom: "5px",
      paddingTop: "10px",
      paddingLeft: "15px",
      marginTop: "10px",
      marginBottom: "5px",
      fontSize: "11px",
      fontWeight: "500",
      color: "#333333",
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    marginRight: {
      marginRight: "15px",
    },
  });
  return (
    <Fragment>
      {expensesData && expensesData.length > 0 ? (
        expensesData?.map((items) => (
          <View style={styles.container}>
            <Text style={styles.one}>
              {items?.transaction_number ? items?.transaction_number : "-"}
            </Text>
            <Text style={styles.two}>
              {items?.transaction_date ? items?.transaction_date : "-"}
            </Text>
            <Text style={styles.three}>
              {items?.merchant_name ? items?.merchant_name : "-"}
            </Text>
            <Text style={styles.four}>
              {items?.category ? items?.category : "-"}
            </Text>
            <Text style={styles.five}>
              {items?.payment_method ? items?.payment_method : "-"}
            </Text>
            <Text style={styles.six}>
              INR {items?.amount ? amountFormat(items?.amount) : "-"}
            </Text>
          </View>
        ))
      ) : (
        <NoData title="Expenses Data" />
      )}
      <View style={styles.anountContainer}>
        <View style={styles.amountText}>
          <Text>Total Expense Amount</Text>
          <Text>Non-reimbursable Amount</Text>
          <Text>Advance Amount</Text>
        </View>
        <View style={styles.amountValues}>
          <Text>INR {amountFormat(data?.total_amount) || 0}</Text>
          <Text>
            (-) INR {amountFormat(data?.total_non_reimbursable_amount) || 0}
          </Text>
          <Text>(-) INR {amountFormat(data?.total_advances_amount) || 0}</Text>
        </View>
      </View>
      <View style={styles.amountFooter}>
        <Text style={styles.marginRight}>Amount to be Reimbursed</Text>
        <Text style={styles.marginRight}>
          INR{" "}
          {amountFormat(
            data?.total_amount -
              data?.total_non_reimbursable_amount -
              data?.total_advances_amount
          ) || 0}
        </Text>
      </View>
    </Fragment>
  );
};

export default ExpenseTableData;
